import{n as e,q as i}from"./chunk-MOWIYUQE.js";import{a,d as s}from"./chunk-FYW7X4VG.js";import{m as n}from"./chunk-HBP5N4FR.js";n();i();s();function T(t){let o=e(a.getState()),r=Object.keys(t).length===(o==null?void 0:o.transactions.length);return t&&(t&&r)}export{T as a};
//# sourceMappingURL=chunk-X2LXJ6A6.js.map
